import type { ResultOf } from '@graphql-typed-document-node/core'
import { atom, useAtomValue } from 'jotai'
import { graphql } from '~/lib/graphql'
import { useInitAtom } from '~/lib/jotai'
import { scope } from './scope'

export const GetTimesale = graphql(`
  query GetTimesale(
    $timesaleId: TimesaleId!
    $device: Device!
  ) {
    timesale(timesaleId: $timesaleId) {
      timesaleId
      name
      reservablePeriod {
        from
        to
      }
      imageUrl(device: $device)
    }
  }
`)

export type Timesale = NonNullable<ResultOf<typeof GetTimesale>['timesale']>

const _timesale$ = scope.atom<Timesale | undefined>(undefined, '_timesale$')
// 外から直接 atom の値を見たいことがあるので export 用の get だけできる derived atom
export const timesale$ = atom((get) => get(_timesale$))
timesale$.debugLabel = 'timesale$'

export function useTimesale() {
  return useAtomValue(_timesale$)
}

export function useHydrateTimesale(timesale: Timesale | undefined) {
  useInitAtom(_timesale$, timesale)
}
